import { useLanguage } from "../../../../stores/LanguageStore";
import {
  ActionIcon,
  Button,
  Popover,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconChevronLeft, IconDownload } from "@tabler/icons-react";
import { useState } from "react";
import { downloadList } from "../../../../api/ContactAPI";
import { notifications } from "@mantine/notifications";

const SelectionListDownload = ({
  rows,
  closeMenu,
  handler,
  label,
  selectedIds,
}) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(null);
  const [opened, setOpened] = useState(false);

  const handleDownload = async (fileType) => {
    setLoading(fileType);

    const main = handler || downloadList;

    let atLeastOneSuccess = false;

    for (const id of selectedIds) {
      try {
        let current = rows.find((row) => row.id === id);
        await main({
          id: id,
          file_type: fileType,
          name: current.name,
        })
          .then((res) => {
            notifications.show({
              message: lang.contact_lists.download_started,
              color: "tertiary.8",
            });
          })
          .finally(() => setLoading(null));
        atLeastOneSuccess = true;
      } catch (error) {
        // notifications.show({
        //   title: `Erreur #${id}`,
        //   message: error.response?.data?.state_message,
        //   color: "red",
        // });
      }
    }

    setLoading(false);
    if (atLeastOneSuccess) {
      setOpened(false);
      closeMenu?.();
    }
  };

  return (
    <Popover
      position="right-start"
      opened={opened}
      onChange={setOpened}
      zIndex={200}
    >
      <Popover.Target>
        <Button
          variant="light"
          className="to-blue"
          justify="start"
          leftSection={<IconDownload size={18} />}
          onClick={() => setOpened(true)}
          disabled={selectedIds?.length < 1}
        >
          {label || lang.contact_lists.download_list}
        </Button>
      </Popover.Target>

      <Popover.Dropdown>
        <Text mb={"xs"}>{lang.contact_lists.download_text} </Text>
        <Stack gap={"sm"}>
          <Button
            variant="light"
            onClick={() => handleDownload("csv")}
            loading={loading === "csv"}
            color="tertiary.8"
          >
            CSV
          </Button>
          <Button
            variant="light"
            onClick={() => handleDownload("xlsx")}
            loading={loading === "xlsx"}
            color="tertiary.8"
          >
            EXCEL
          </Button>
          <Button
            variant="light"
            onClick={() => handleDownload("json")}
            loading={loading === "json"}
            color="tertiary.8"
          >
            JSON
          </Button>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};

export default SelectionListDownload;
